import { render } from "./SecondReportPie.vue?vue&type=template&id=45f64e97&scoped=true"
import script from "./SecondReportPie.vue?vue&type=script&lang=js"
export * from "./SecondReportPie.vue?vue&type=script&lang=js"

import "./SecondReportPie.vue?vue&type=style&index=0&id=45f64e97&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f64e97"]])

export default __exports__